// extracted by mini-css-extract-plugin
export default {"button":"z-button_button__joLHt","button__disabled":"z-button_button__disabled__JA+TO","button__label":"z-button_button__label__hvzUu"};